import React, { useEffect, useState } from 'react'
import { HabilitationAccordion } from '../access/HabilitationAccordion'
import { PLUVIO } from '../../../constants/ApplicationHabilitationConstants'
import i18n from '../../../../../../simple-react-i18n'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import PluviometryAction from '../../../../../../pluviometry/actions/PluviometryAction'
import PluviometerDto from '../../../../../../pluviometry/dto/PluviometerDto'

const HabilitationPluvio = ({}) => {
    const dispatch = useDispatch()
    const {
        pluviometers,
    } = useSelector(store => ({
        pluviometers: store.PluviometryReducer.pluviometers,
    }), shallowEqual)

    const [isLoaded, setIsLoaded] = useState(false)

    useEffect(() => {
        if (pluviometers.length === 0) {
            dispatch(PluviometryAction.fetchPluviometers())
                .then(() => setIsLoaded(true))
        } else {
            setIsLoaded(true)
        }
    }, [dispatch])

    return (
        <HabilitationAccordion
            stationType={PLUVIO}
            title={i18n.pluviometry}
            stations={pluviometers}
            isLoaded={isLoaded}
        />
    )
}

HabilitationPluvio.propTypes = {
    pluviometers: PropTypes.arrayOf(PropTypes.instanceOf(PluviometerDto)),
    fetchPluviometers: PropTypes.func,
}

export default HabilitationPluvio